import { AllergyResponse } from "../models/allergy.interface";
import { SoapNote } from "../models/dictation.interface";
import { Immunization } from "../models/immunization.interface";
import { Labhistory } from "../models/labhistory";
import { MedicationRequest } from "../models/medical-request.interfcae";
import { VitalSigns } from "../models/vital-signs.interface";
import { ROUTE_CONSTANTS } from "./route.constants";

export const CVA_CONSTANTS = {
  NAVIGATION_BUTTONS: [
    {
      icon: 'dashboard',
      title: 'Patient Dashboard',
      route: `/${ROUTE_CONSTANTS.PATIENT_DASHBOARD}`,
    },
    {
      icon: 'settings',
      title: 'Settings / User Preferences',
      route: `/${ROUTE_CONSTANTS.SOAP_CONFIGURATION}`,
    }
  ],
  SOAP_COLORS: {
    subjective: 'rgba(145, 206, 136, 1)',
    objective: 'rgba(122, 214, 227, 1)',
    assessment: 'rgba(185, 162, 250, 1)',
    plan: 'rgba(251, 185, 85, 1)',
  },
  DISABLE_NAVIGATION: ['/login', '/forgot-password', '/sign-up'],
  CONSTS: {
    soap_setting: 'SOAP_SETTINGS',
    template_type: 'TEMPLATE_TYPE',
    patient_consent: 'PATIENT_CONSENT',
    user_preference: 'USER_PREFERENCE'
  },
  PERMISSION: {
    READ: 'read',
    WRITE: 'write',
    UPDATE: 'update',
    DELETE: 'delete'
  },
  MESSAGE: {
    CHANGE_PASSWORD_SUCCESS: 'Password updated successfully. Please login.',
    CHANGE_PASSWORD_ERROR: 'Error occurred while changing password.',
    invalid_credentials: 'You have entered invalid credentials, please try again.',
    empty_soap_notes: 'Resources can not be empty.',
    empty_soap_notes_classic: 'Notes can not be empty.',
    save_soap_notes: 'Notes saved successfully.',
    save_err_soap_notes: 'Error while Saving.',
    empty_medication_name: 'Medication name can not be empty.',
    NO_RECORD_FOUND: 'No Record Found.',
    UNABLE_TO_CANCEL_THE_APPOINTMENT: 'Unable to cancel the appointment. Please try again.',
    UNABLE_TO_FETCH_RECORDS: 'Unable to fetch records.',
    DELETE_CONFIRMATION_MESSAGE: 'Do you really want to cancel this appointment?',
    APPOINTMENT_BOOKED_SUCCESSFULLY: 'Appointment booked successfully.',
    APPOINTMENT_CANCELLED_SUCCESSFULLY: 'Appointment cancelled successfully.',
    SOAP_SETTINGS_SAVED_SUCCESSFULLY: 'SOAP settings saved successfully.',
    UNABLE_TO_CANCEL_THE_PAST_APPOINTMENT: 'Unable to cancel the past appointment.',
    NO_SLOTS_FOUND: 'No available slots for the selected date.',
    MISSING_MANDATORY_FIELDS: 'Fill out mandatory fields.',
    PATIENT_NOT_FOUND: 'No patient found with this id.',
    NLP_ERROR: 'NLP service is down.',
    EDIT_SECTION_ERROR: 'Please select section to edit.',
    AGE_LIMIT_ERROR: 'Age cannot be below 0 and above 100.',
    INVALID_VITAL: 'Only numeric values are allowed for ',
    FUTURE_DATE_ERROR: 'Future date is not allowed.',
    BIRTH_DATE_ERROR: 'Date cannot be older than date of birth.',
    INVALID_GENDER: 'Please enter valid gender.',
    INVALID_RELATION: 'Please enter valid relation.',
    INVALID_BP: 'Only numeric values are allowed for blood pressure with slash(/).',
    UNAUTHORIZED: 'Unauthorized',
    PENDING_NOTES_WARNING: 'You have unapproved notes from the previous appointment. If you start a new appointment, these notes will be deleted. Are you sure you want to continue?',
    ACCOUNT_EXPIRY_REMINDER: 'Your Account will be expired in {count} days.',
    CANCEL_APPOINTMENT_WITH_PENDING_NOTES_WARNING: 'Pending notes exist for this appointment. Are you sure you want to cancel this appointment?',
    UNABLE_TO_CANCEL_ONGOING_APPOINTMENT: "Cancellation of this appointment is not possible as the consultation is currently in progress.",
    TRANSCRIPTION_UPDATED: 'Transcription updated successfully.',
    CONSULTATION_ALREADY_DONE: 'The consultation was already submitted for this appointment, do you want to continue with new consultation.',
    ERR_GET_AI_SOAP_NOTES: 'Not able to parse the data from AI.',
    NOT_MENTION: 'not provided',
    save_err_vitals: "Error occurred while saving Vitals.",
    PASSWORD_CHANGED_SUCCESSFULLY: 'Password changed successfully.',
    FORGOT_PASSWORD_LINK_SENT: 'If the provided email is associated with an account, you will receive a password reset link shortly.',
    FORGOT_PASSWORD_ERROR: 'Email does not found! Are you sure you are already a member?',
    CONSULTATION_DISCLAIMER: 'By Starting Consultation you confirm having received approval from the patient to record the session.',
    GENERATE_SOAP_NOTE_ERR: "There's a temporary problem with the service. If you continue to get this message, please contact product.support@intellitek.ai",
    GENERATE_VITALS_ERR: "Unable to generate vitals. Please try again later.",
    TEXTAREAR_PLACEHOLDER: " Welcome to AI-Enhanced \n Online Consultation! \n\n Click on mic icon to proceed.",
    SCREENING_TERM_FETCH_ERROR: "Error occurred while fetching list of available screening terms.",
    VITALS_MAPPING_FETCH_ERROR: "Error occurred while fetching vitals mapping.",
    VITALS_MAPPING_SAVED: "Vitals Mapping Saved.",
    VITALS_MAPPING_SAVE_FAILUR: "Vitals Mapping could not be saved. Please try again later.",
    INVALID_RESET_PASSWORD_LINK: "Invalid or expired link. Please click on 'Generate New Link' button to receive a new link via email.",
    COPY_SUCCESS: "Copied to clipboard!",
    LOADING_NOTE: "Loading up your note, template is on the way ...",
    TURNING_NOTE_INTO_TEMPLATE: "Turning your note into a template...",
    TURNING_FILE_INTO_TEMPLATE: "Turning your file into a template...",
    FILE_GETTING_READY: "Your file is getting ready to become a template!",
    UNABLE_TO_GENERATE: 'Unable to generate template.',
    TEMPLATE_DELETED: 'Template deleted successfully.',
    TEMPLATE_SAVED_SUCCESSFULLY: 'Template saved successfully.',
    TEMPLATE_UPDATED_SUCCESSFULLY: 'Template updated successfully.',
    UNABLE_TO_SAVE_TEMPLATE: 'Unable to save template',
    UNABLE_TO_UPDATE_TEMPLATE: 'Unable to update template',
    CONFIRM_TO_DELETE_TEMPLATE: 'Deleting this template will also remove all notes generated from it. Are you sure, you want to delete this template?',
    ERROR_ON_GENERATING_PREVIEW: 'Unable to generate the preview.',
    CONFIRM_TO_MARK_TEMPLATE_FAV: 'Are you sure you want to add this template to your favorites?',
    CONFIRM_TO_UN_MARK_TEMPLATE_FAV: 'Are you sure you want to remove this template from your favorites?',
    UNABLE_TO_PROCESS: 'Unable to process the request.',
    SAVED_PRACTISE_FORM: 'Your request has been successfully submitted. Our team will be in touch with you shortly.',
    LIC_AUTH_FAILED: 'Authentication failed. Please contact support at https://st21products.atlassian.net/servicedesk/customer/portal/1',
    MANUAL_ERR: 'No new records available at the moment. Please try again later.',
    VITAL_ERR: 'Vitals data is unavailable for this facility.',
    NO_APPOINTMENT: 'Appointments could not be loaded at this time. Please try again later.',
    NO_WALK_IN_APPOINTMENT: 'Walkins could not be loaded at this time. Please try again later.',
    CREATE_APPOINTMENT_ERR: 'Unable to book the appointment at this time. Please try again later.',
    NO_PROVIDER: 'No Provider found.',
    DELETE_TAB_ERROR: 'Error occurred while deleting the tabs. Please logout and login again.',
    UNKNOWN_LOGIN_ERR: 'Error occurred while logging in.',
    ACCOUNT_LOCKED: 'Your account is locked. Please contact the administrator.',
    INACTIVE_ACCOUNT: 'Your account is currently inactive. Please contact support for assistance.',
    EXISTING_CONSULTATION: "There's an active consultation with another patient right now. Would you like to end this consultation and begin a new one?",
    EXISTING_SAME_CONSULTATION: "There's an active consultation with same patient right now. Would you like to end this consultation and begin a new one?",
    PATIENT_CONSENT: "For the most accurate and efficient note-taking, I'd like to use digital transcription during our session. Do you approve of this?",
    CONSULTATION_ALLOWED_ONLY_FOR_TODAY: "Consultation can be started only for today's appointments.",
    SHOW_CONSENT_POPUP: "When this is turned on, you'll get a pop-up at the start of each session asking you to get the patient’s consent to record.",
    CONSENT_POPUP: "Enable showing patient consent pop-up on start of every session.",
    PATIENT_CONSENT_POPUP: 'Patient consent saved successfully.',
    CONSULTATION_NOTE_FONT: 'Font size for patient consultation note saved successfully.',
    APPROVE_POPUP_NOTE: 'Approve popup saved successfully.',
    PATIENT_HISTORY_NOTE: 'Patient history preference updated successfully.',
    TASK_ADDED_SUCCESSFULLY: 'All selected tasks were created successfully.',
    TASK_ADDED_ERR: 'task(s) could not be created, please retry again.',
    MEDICATION_ADDED_SUCCESSFULLY: 'All selected medication(s) were created successfully.',
    MEDICATION_ADDED_ERR: 'medication(s) could not be created, please retry again.',
    MEDICATION_ADDED_ERR_NOTE: 'Below are the failed medication(s):',
    CONDITION_ADDED_SUCCESSFULLY: 'All selected classification(s) were created successfully.',
    CONDITION_ADDED_ERR: 'Selected classification(s) could not be created, please retry again.',
    CLASSIFICATION_FETCH_ERROR: 'Error occurred while fetching classifications.',
    INVALID_USER: 'Invalid User!',
    SESSION_EXPIRED: "Your session has expired. Please log in again.",
    ACC_ELIGIBILITY_ADDED_SUCCESSFULLY: 'Tasks successfully created from selected ACC Codes',
    ACC_ELIGIBILITY_ADDED_ERR: 'Could not create tasks from selected ACC codes. Please try again.',
    RECIPIENTS_ERROR: 'Unable to load the recipient list. Please try again later',
    ACC_ELIGIBILITY_RECIPIENT: 'Default ACC coding task recipient updated successfully',
    SHOW_LIVE_TRANSCRIPTION: 'Live transcription setting updated successfully.'
  },
  REGEX: {
    // eslint-disable-next-line no-useless-escape
    specialCharacter: /[!@#$%^&*()+=._\-?]$/,
    ordinalDateRegex: /\d{1,2}(st|nd|rd|th)/i,
    patterns: [
      /\bpractitionerId\s*=\s*([^&]+)/,
      /\bappointmentId\s*=\s*([^&]+)/,
      /\bflt\s*=\s*([^&]+)/,
      /\btoken\s*=\s*([^&]+)/,
      /\bfacility\s*=\s*([^&]+)/,
    ],
    titleInput: /^[a-zA-Z0-9 _&,\-.]*$/,
    patientName: /^[a-zA-Z0-9,.&\s-]*$/,
  },

  USER_SETTING_TYPES: {
    VITALS_MAPPING: 'VITALS_MAPPING'
  },
  // V1_TEMPLATE_IDENTIFIERS: ['soap-classic', 'soap-lite', 'issues-lite', 'soap-psycho-task', 'soap-psycho-socialc']
  V1_TEMPLATE_IDENTIFIERS: []
};

export const PATIENT_ID = 'patientId';
export const APPOINTMENT_ID = 'appointmentId';

export enum AppointmentStatusEnum {
  PROPOSED = 'proposed',
  PENDING = 'pending',
  BOOKED = 'booked',
  ARRIVED = 'arrived',
  FULFILLED = 'fulfilled',
  CANCELLED = 'cancelled',
  NOSHOW = 'noshow',
  ENTERED_IN_ERROR = 'entered-in-error',
  CHECKED_IN = 'checked-in',
  WAITLIST = 'waitlist',
}

export enum MANUAL_REFRESH_IDENTIFIER {
  PRACTITIONER_APPOINTMENT = 'practitioner_appointment',
  PATIENT_APPOINTMENT = 'patient_appointment',
  PRACTITIONER_PATIENT_APPOINTMENT = 'practitioner_patient_appointment',
  ALLERGY = 'allergy',
  SOAP_NOTE = 'soap_note',
  OBSERVATIONS = 'observations',
  IMMUNIZATION = 'immunization',
  MEDICATION_REQUEST = 'medication_request',
  LAB_RESULTS = 'lab_results'
}

export enum StorageKeys {
  SELECTED_APPOINTMENT = 'selectedAppointment',
  CURRENT_APPOINTMENT = 'currentAppointment',
  PROVIDER_ID = 'providerId',
  FACILITY_CODE = 'facilityCode',
  FACILITY_NAME = 'facilityName',
  TELEHEALTH_TOUR_TAKEN = 'telehealthTourTaken'
}

export enum Relation {
  RELATIONS = "Family Member/ Child/ Adopted Child/ Adopted Daughter/ Adopted Son/ Foster Child/ Foster Daughter/ Foster Son/ Daughter/ Natural Daughter/ Step Daughter/ Natural Child/ Natural Son/ Son/ Step Son/ Step Child/ Father/ Mother/ Grandfather/ Grandmother/ Brother/ Sister"
}

export enum TAB {
  SOAP_NOTES = 1,
  TRANSCRIPTION = 0
}

export enum VIEW_MODE {
  GRID = 'grid',
  TAB = 'tab'
}
export interface IPatientDemography {
  name: string;
  dateOfBirth: string;
  gender: string;
}
export interface IHistoricalData {
  consultation: SoapNote[];
  vitals: VitalSigns[];
  allergies: AllergyResponse[];
  labResult: Labhistory[];
  medication: MedicationRequest[];
  immunization: Immunization[]
}
export const allergiesColumns = [
  {
    field: 'allergen',
    label: 'Allergen',
  },
  {
    field: 'type',
    label: 'Type',
  },
  {
    field: 'category',
    label: 'Category',
  },
  {
    field: 'criticality',
    label: 'Criticality',
  },

  {
    field: 'clinicalStatus',
    label: 'Clinical Status',
  },
  {
    field: 'verificationStatus',
    label: 'Verification Status',
  },
  {
    field: 'onsetDate',
    label: 'Onset Date',
  },
  {
    field: 'recordedDate',
    label: 'Last Occurred On',
  },
];
export const medicationColumns = [
  {
    field: 'medication',
    label: 'Medication'
  },
  {
    field: 'duration',
    label: 'Duration',
  },
  {
    field: 'qty',
    label: 'Quantity',
  },
  {
    field: 'route',
    label: 'Route',
  },
  {
    field: 'instruction',
    label: 'Instruction',
  },
];
export const immunizationColumns = [
  {
    field: 'displayName',
    label: 'Vaccine Name',
    tdClass: "normal-text"
  },
  {
    field: 'occurrenceDate',
    label: 'Occurrence Date',
    tdClass: "normal-text"
  },
  {
    field: 'expirationDate',
    label: 'Expiration Date',
    tdClass: "normal-text"
  },
  {
    field: 'status',
    label: 'Status ',
    tdClass: "normal-text"
  },
  { field: "note", label: "Note", width: "15%", tdClass: "notes-field normal-text text-break", hasLargeText: true },
  {
    field: 'practitionerName',
    label: 'Performer',
    tdClass: "normal-text"
  }

];

export enum MicrophoneErrorMessages {
  NotAllowedError = "Microphone access was denied. Please allow microphone access in your browser settings.",
  NotFoundError = "No microphone was found. Please make sure your microphone is connected and try again.",
  NotReadableError = "Your microphone is currently in use by another application. Please close other apps that might be using the microphone.",
  NotSupportedError = "Your browser does not support microphone access. Please use a supported browser like Chrome or Firefox.",
  SecurityError = "Microphone access is blocked due to security settings. Please access the site via HTTPS or change your browser settings.",
  AbortError = "Microphone access was aborted. Please retry and allow access when prompted.",
  OverconstrainedError = "Your device does not meet the required microphone settings. Please check if the correct device is selected.",
  InvalidStateError = "Microphone access cannot be processed at this time. Please refresh the page and try again.",
  TypeError = "There was an issue with microphone access. Please reload the page and try again.",
  UnknownError = "An unknown error occurred while accessing the microphone. Please try again."
}

export enum DisplayMediaErrorMessages {
  NotAllowedError = 'Screen sharing was cancelled or denied. Please click "Share" and ensure "Share audio" is checked.',
  NotFoundError = 'No screen or window available to share. Please try again.',
  NotReadableError = 'Unable to capture screen. Please close other apps that might be using screen capture and try again.',
  AbortError = 'Screen sharing was cancelled. Please try again if you want to use Telehealth mode.',
  InvalidStateError = 'Screen sharing is in an invalid state. Please refresh the page and try again.',
  NotSupportedError = 'Your browser does not support screen sharing. Please use Chrome or Edge.',
  NoAudioTrack = 'No audio track found in screen share. Please ensure "Share audio" is checked when sharing.',
  UnknownError = 'Could not start Telehealth mode. Please try again.'
}

export const MESSAGES = {
  AUDIO_CHUNK_DROPPED: 'Unable to transcribe part of the recording. Please check your internet connection and try again',
  MIC_DEVICE_SELECTED: 'Microphone device selected. Changes will apply on next recording.',
  MIC_DEVICE_UNAVAILABLE: 'Selected microphone unavailable. Using default microphone.',
  SCREEN_SHARE_STOPPED: 'Screen sharing stopped. Recording has been stopped.',
  MIC_DISCONNECTED: 'Microphone disconnected. Recording has been stopped.',
  TELEHEALTH_NOT_READY: 'Telehealth audio is not ready. Please share a tab with audio and try again.',
  TELEHEALTH_UNSUPPORTED: 'Telehealth is available in Chrome or Edge. Please switch browsers to use screen-share audio.',
  AUDIO_NO_SPEECH_WARNING: "Are you speaking? We couldn't hear you. Please check that your microphone is on and close to you.",
  AUDIO_NO_SPEECH_AUTO_STOPPED: "Recording stopped: we couldn't hear any voice. Please check your microphone and start again.",
}